import { SwapOutlined } from '@ant-design/icons'
import type { ColumnDef } from '@tanstack/react-table'
import { Tag } from 'antd'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import { SupplierDirectoryItemDto } from '@/types'

import cn from './SuppliersTab.module.scss'

export const SUPPLIERS_COLUMN_WIDTHS: Partial<Record<string, string>> = {
  description: 'minmax(200px, 1.2fr)',
  legalAddress: 'minmax(220px, 1.5fr)',
  contactPhone: '170px',
  status: '160px',
  actions: '190px',
}
const canInvite = (item: SupplierDirectoryItemDto): boolean => {
  const p = item.partnershipShortDto
  if (!p) return true
  return p.status === 'TERMINATED' || p.status === 'REJECTED'
}

const getStatusBadge = (item: SupplierDirectoryItemDto) => {
  const p = item.partnershipShortDto
  if (!p) return null
  const map: Record<string, { color: string; label: string }> = {
    PROPOSED: { color: 'processing', label: 'Ожидает ответа' },
    ACTIVE: { color: 'success', label: 'Активное' },
    TERMINATED: { color: 'default', label: 'Расторгнуто' },
    REJECTED: { color: 'error', label: 'Отклонено' },
  }
  const conf = map[p.status]
  return conf ? <Tag color={conf.color}>{conf.label}</Tag> : null
}

export const getSuppliersColumns = (
  onInvite: (item: SupplierDirectoryItemDto) => void
): ColumnDef<SupplierDirectoryItemDto, unknown>[] => [
  {
    id: 'description',
    header: 'Наименование',
    cell: (info) => (
      <span className={cn.nameCell}>
        {info.row.original.supplier.description}
      </span>
    ),
  },
  {
    id: 'legalAddress',
    header: 'Юр. адрес',
    cell: (info) => (
      <span className={cn.legalName}>
        {info.row.original.supplier.legalAddress || '—'}
      </span>
    ),
  },
  {
    id: 'contactPhone',
    header: 'Телефон',
    cell: (info) => (
      <span>{info.row.original.supplier.contactPhone || '—'}</span>
    ),
  },
  {
    id: 'status',
    header: 'Статус',
    cell: (info) => getStatusBadge(info.row.original),
  },
  {
    id: 'actions',
    header: '',
    cell: (info) => {
      const item = info.row.original
      if (!canInvite(item)) return null
      const isRenew = item.partnershipShortDto !== null
      return (
        <AtomButton
          className={cn.requestButton}
          icon={<SwapOutlined />}
          onClick={() => onInvite(item)}
        >
          {isRenew ? 'Возобновить' : 'Запросить'}
        </AtomButton>
      )
    },
  },
]
